<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><span><img alt="2010-11-08T18-23-50-706_9781550924589_0034_001" class="imgpub" id="d14e556" src="Images/2010-11-08T18-23-50-706_9781550924589_0034_001.jpg"/></span></p>
<p class="h1c" id="d7e264334"><span>collards</span></p>
<p class="txca" id="d7e264834"><span><span href="#/Text/Morg_9781550924589_epub_c48_r1#d7e879389" id="d14e560" title="Link target outside of Sample">caldo verde</span></span></p>
<p class="txca" id="d7e2644834"><span><span href="#/Text/Morg_9781550924589_epub_c85_r1#d7e13189129" id="d14e563" title="Link target outside of Sample">spiced lentils and collard greens</span></span></p>
<p class="txca" id="d7e2584834"><span><span href="#/Text/Morg_9781550924589_epub_c105_r1#d7e16011149" id="d14e566" title="Link target outside of Sample">feijoada</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morg_9781550924589_epub_c15_r1.vue?5689462f